export default __webpack_public_path__ + "static/media/java.6013cee1.svg";